// ComboBoxAutoComplete.js
import React from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import "./new/narrowInput.css";

const ComboBoxAutoComplete = ({
  title,
  placeholder,
  options,
  value,
  inputValue, // New prop for controlling the input's value
  onInputChange,
  onChange,
  getOptionLabel = (option) =>
    typeof option === "string" ? option : option.title || "",
  isLoading = false,
  error = "",
}) => {
  return (
    <div className="combo-box-autocomplete">
      <label className="input-label">{title}</label>
      <Autocomplete
        freeSolo
        options={options}
        getOptionLabel={getOptionLabel} // Handles both string and object options
        value={value}
        inputValue={inputValue} // Controls the input's displayed value
        loading={isLoading}
        sx={{ mb: 5 }}
        onInputChange={(event, newInputValue) => onInputChange(newInputValue)}
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={placeholder}
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root": {
                height: "45px",
              },
              "& .MuiOutlinedInput-input": {
                padding: "0 8px",
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </>
              ),
              inputProps: {
                ...params.inputProps,
                className: "narrow-input-field", // <-- apply your styles here
              },
            }}
            error={Boolean(error)}
            helperText={error}
          />
        )}
      />
    </div>
  );
};

export default ComboBoxAutoComplete;
